import { faUser } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { INTERNAL_LOGIN } from '../../router/routes';

import { useService } from '../../services/services';
import { guard, user } from '../../store/global-slice';
import { RootState } from '../../store/store';
import GlobalProgressBar from '../global-progress-bar';
import css from './topbar.module.css';

export default function Topbar() {
  const { t } = useTranslation();
  const history = useHistory();
  const { internalAuthService } = useService();
  const dispatch = useDispatch();

  const { userState } = useSelector((state: RootState) => ({
    userState: state.global.user,
  }));

  const logout = () => {
    internalAuthService.logout().subscribe((response) => {
      dispatch(user(null));
      dispatch(guard(null));
      history.push(INTERNAL_LOGIN);
    });
  };

  return (
    <div className={css['topbar']}>
      <div className={css['content']}>
        <div className={css['avatar']}>
          <FontAwesomeIcon icon={faUser} />
        </div>
        <span className={css['username']}>{userState?.name}</span>
        <div className={css['divider']}>&nbsp;</div>
        <button name="logout" className={css['logout']} onClick={logout}>
          {t('Logout')}
        </button>
      </div>
      <GlobalProgressBar />
    </div>
  );
}
